import { LoadingPlaceholder } from '@/common/components/LoadingPlaceholder/LoadingPlaceholder';
import { ROUTES } from '@/common/constants/routes';
import { useFeatures } from '@/common/integrations/feature-flag/feature-flag.hooks';
import { AuthenticationLayout } from '@/web/layouts/AuthenticationLayout/AuthenticationLayout';
import { Slot, usePathname } from 'expo-router';

export default function PublicLayout() {
  const pathname = usePathname();
  const {
    features: { ff_sea_authentication },
    isInitialLoading,
  } = useFeatures();

  if (isInitialLoading) {
    return <LoadingPlaceholder />;
  }

  if (ff_sea_authentication && isPageMigrated(pathname)) {
    return <Slot />;
  }

  return (
    <AuthenticationLayout>
      <Slot />
    </AuthenticationLayout>
  );
}

/**
 * Check if the page is migrated to the new authentication layout
 * We can leave this here locally because we have only a couple pages to migrate to this layout
 */
function isPageMigrated(pathname: string) {
  const pages: string[] = [
    ROUTES.SIGNIN,
    ROUTES.OTP,
    ROUTES.BIOMETRICS,
    ROUTES.NOTIFICATIONS,
    ROUTES.SSO_SIGNIN,
    ROUTES.RESET_PASSWORD,
    ROUTES.SIGNUP,
  ];
  return pages.includes(pathname);
}
